var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89474 2.39474C3.23788 2.39474 1.89474 3.73788 1.89474 5.39474C1.89474 7.05159 3.23788 8.39474 4.89474 8.39474C6.55159 8.39474 7.89474 7.05159 7.89474 5.39474C7.89474 3.73788 6.55159 2.39474 4.89474 2.39474ZM0 5.39474C0 2.69145 2.19145 0.5 4.89474 0.5C7.59803 0.5 9.78947 2.69145 9.78947 5.39474C9.78947 8.09803 7.59803 10.2895 4.89474 10.2895C2.19145 10.2895 0 8.09803 0 5.39474Z",
    fill: "#FB0F42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01611 7.51611C7.38608 7.14614 7.98592 7.14614 8.35589 7.51611L11.7225 10.8827C12.0925 11.2527 12.0925 11.8526 11.7225 12.2225C11.3526 12.5925 10.7527 12.5925 10.3827 12.2225L7.01611 8.85589C6.64614 8.48592 6.64614 7.88608 7.01611 7.51611Z",
    fill: "#FB0F42"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.0dcb9516.svg";
export { ForwardRef as ReactComponent };